import { BrowserRouter, Routes, Route, Switch } from "react-router-dom";

import React, {
  useState,
  useEffect,
  useContext,
  Component,
  Suspense,
  lazy,
} from "react";

import {
  CPHandlerProvider,
  CPHandlerContext,
} from "./context/CPHandlerProvider";

const { GoogleLogout } = lazy(() => import("react-google-login"));

const ClassDoc = lazy(() => import("./pages/Classes-doc"));
const FormPreview = lazy(() => import("./pages/form_builder/FormPreview"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const NotFound = lazy(() => import("./pages/NotFound"));
const ChatDash = lazy(() => import("./pages/chat/ChatScreen"));
const ChatsListPopup = lazy(() => import("./pages/chat/ChatsListPopup"));
const ChatMessageView = lazy(() => import("./pages/chat/ChatMessageView"));
const ChatBlockedIPs = lazy(() => import("./pages/chat/ChatBlockedIPs"));

const ChatDomainList = lazy(() => import("./pages/chat_domain/List"));

const NLTK = lazy(() => import("./pages/NLTK"));

const RecordList = lazy(() => import("./pages/records/List"));

const InboxList = lazy(() => import("./pages/inbox/List"));

const LeadBoard = lazy(() => import("./pages/leads/Board"));
const LeadAddNew = lazy(() => import("./pages/leads/LeadAddNew"));
const LeadsList = lazy(() => import("./pages/leads/LeadsList"));
const LeadView = lazy(() => import("./pages/leads/LeadView"));
const LeadEdit = lazy(() => import("./pages/leads/LeadEdit"));
const LeadEditTest = lazy(() => import("./pages/leads/LeadEditTest"));
const LeadCRM = lazy(() => import("./pages/leads/LeadCRM"));
const LeadIncoming = lazy(() => import("./pages/leads/LeadIncoming"));
const LeadClientDash = lazy(() => import("./pages/leads/LeadClientDash"));
const LeadCatsList = lazy(() => import("./pages/lead_cats/List"));
const LeadCalls = lazy(() => import("./pages/leads/LeadCalls"));
const LeadSms = lazy(() => import("./pages/leadsms/List"));
const LeadAssignedUser = lazy(() => import("./pages/leads/LeadAssignedUser"));
const LeadSetting = lazy(() => import("./pages/leads/LeadSetting"));

const LeadContactList = lazy(() => import("./pages/leadcontacts/List"));

const LeadMails = lazy(() => import("./pages/leadmails/List"));

const LeadTypeList = lazy(() => import("./pages/leadtype/List"));
const LeadEmailGroupList = lazy(() => import("./pages/leademailgroup/List"));

const LeadStatusList = lazy(() => import("./pages/leadstatus/List"));

const TwilioIncoming = lazy(() => import("./pages/caller/Incoming"));
const TwilioToken = lazy(() => import("./pages/caller/Token"));
const TwilioOutgoing = lazy(() => import("./pages/caller/Outgoing"));

const HtmlBlocksList = lazy(() => import("./pages/html_blocks/List"));
const HtmlBlocksSetList = lazy(() => import("./pages/html_blocks_set/List"));

const BenefitList = lazy(() => import("./pages/benefit/List"));
const BenefitSetList = lazy(() => import("./pages/benefit_set/List"));

const TestimonialList = lazy(() => import("./pages/testimonial/List"));
const TestimonialSetList = lazy(() => import("./pages/testimonial_set/List"));

const ObjectionList = lazy(() => import("./pages/objection/List"));
const ObjectionSetList = lazy(() => import("./pages/objection_set/List"));

const LPBuilder = lazy(() => import("./pages/lp_builder/LPBuilder"));

const FaqList = lazy(() => import("./pages/faq/List"));
const FaqCatsList = lazy(() => import("./pages/faq_cats/List"));
const FaqTagsList = lazy(() => import("./pages/faq_tags/List"));
const FaqSynonymsList = lazy(() => import("./pages/faq_synonyms/List"));
const FaqQuesList = lazy(() => import("./pages/faq_ques/List"));
const FaqAnsList = lazy(() => import("./pages/faq_ans/List"));

const FaqChattrainingList = lazy(() => import("./pages/faq_chat_trainings/List"));

const SnippetsList = lazy(() => import("./pages/faq_snippets/List"));

const ChatPicAdd = lazy(() => import("./pages/faq_chat_pic/Add"));

const NcmForm = lazy(() => import("./pages/ncm_form/Add"));
const GmailApi = lazy(() => import("./pages/gmail_api/Add"));
const GoogleToken = lazy(() => import("./pages/gmail_api/Token"));

const FaqSuggestedList = lazy(() => import("./pages/faq_suggested/List"));
const FaqSuggestedAdd = lazy(() => import("./pages/faq_suggested/Add"));
const FaqSuggestedEdit = lazy(() => import("./pages/faq_suggested/Edit"));

const FaqSuggestedAdd_v2 = lazy(() => import("./pages/faq_suggested_v2/Add"));
const FaqSuggestedEdit_v2 = lazy(() => import("./pages/faq_suggested_v2/Edit"));

const PostList = lazy(() => import("./pages/post/List"));
const PostCatList = lazy(() => import("./pages/post_cat/List"));

const PostSettingList = lazy(() => import("./pages/post_settings/List"));
const PostUpdate = lazy(() => import("./pages/post_settings/Add"));
const PostByname = lazy(() => import("./pages/post_settings/Edit"));

const PagesList = lazy(() => import("./pages/pages/List"));
const WebsitesList = lazy(() => import("./pages/websites/List"));
const SiteList = lazy(() => import("./pages/sites/List"));
const PagesAdd = lazy(() => import("./pages/pages/Add"));
const PagesEdit = lazy(() => import("./pages/pages/Edit"));

const MessageList = lazy(() => import("./pages/message/List"));

const AccordionList = lazy(() => import("./pages/accordion/List"));

const QuotesList = lazy(() => import("./pages/quotes/List"));

const ShowcasesList = lazy(() => import("./pages/showcases/List"));

const VideosList = lazy(() => import("./pages/videos/List"));

const ContactTextList = lazy(() => import("./pages/contact_text/List"));

const VirtualToursList = lazy(() => import("./pages/virtual_tours/List"));

const WidgetSettingList = lazy(() => import("./pages/widget_setting/List"));

const OffersFormList = lazy(() => import("./pages/offers_form/List"));

const CustomFormList = lazy(() => import("./pages/custom_form/List"));

const SiteThemeList = lazy(() => import("./pages/site_theme/List"));

const FormBuilderList = lazy(() => import("./pages/form_builder/List"));

const FormEntriesList = lazy(() => import("./pages/form_entries/List"));

const OffersGroupsList = lazy(() => import("./pages/offer_groups/List"));

const EmailTempsList = lazy(() => import("./pages/email_temps/List"));

const EmailGroupsList = lazy(() => import("./pages/email_groups/List"));

const EmailFilteringList = lazy(() => import("./pages/email_filters/List"));

const WidgetImageSettingList = lazy(() => import("./pages/widget_image_setting/List"));

const WorkbooksList = lazy(() => import("./pages/workbooks/List"));
const WorkbookEditor = lazy(() => import("./pages/workbooks/Editor"));

const HeroesList = lazy(() => import("./pages/heroes/List"));

const ClientGalleryImagesList = lazy(() => import("./pages/clientgalleryimages/List"));

const ClientStoryBoardsList = lazy(() => import("./pages/clientstoryboards/List"));

const FollowUpEmailTempsAdd = lazy(() => import("./pages/followup_email_temps/Add"));
const FollowUpEmailTempsEdit = lazy(() => import("./pages/followup_email_temps/Edit"));

const FollowUpEmailGroupsAdd = lazy(() => import("./pages/followup_email_groups/Add"));
const FollowUpEmailGroupsEdit = lazy(() => import("./pages/followup_email_groups/Edit"));

const MediaList = lazy(() => import("./pages/media/List"));
const MediaPhotosList = lazy(() => import("./pages/media_photos/List"));
const MediaVideosList = lazy(() => import("./pages/media_videos/List"));

const ClientsList = lazy(() => import("./pages/clients/List"));

const GroupsAdd = lazy(() => import("./pages/groups/Add"));
const GroupsEdit = lazy(() => import("./pages/groups/Edit"));

const UsersList = lazy(() => import("./pages/users/List"));

const RolesAdd = lazy(() => import("./pages/roles/Add"));
const RolesEdit = lazy(() => import("./pages/roles/Edit"));

const PermissionsAdd = lazy(() => import("./pages/permissions/Add"));
const PermissionsEdit = lazy(() => import("./pages/permissions/Edit"));

const LpsessionAdd = lazy(() => import("./pages/lpsessions/Add"));
const LpsessionEdit = lazy(() => import("./pages/lpsessions/Edit"));

const TemplatesList = lazy(() => import("./pages/templates/List"));
const Kanban = lazy(() => import("./pages/templates/Kanban"));

const ThemesList = lazy(() => import("./pages/themes/List"));

const LandingPageList = lazy(() => import("./pages/landing_page/List"));

const VarTextsAdd = lazy(() => import("./pages/landing_page/vartexts/Add"));
const VarTextsEdit = lazy(() => import("./pages/landing_page/vartexts/Edit"));

const TestAdd = lazy(() => import("./pages/test/Add"));
const TestEdit = lazy(() => import("./pages/test/Edit"));

// Redirect to 404 if client_id in URL does not match with active client ID
const loginData = JSON.parse(localStorage.getItem("userData"));
const acIds = loginData?.data?.assigned_client_ids;
const currentClientId = acIds && acIds.length > 0 ? acIds[0] : null;

const urlParams = new URLSearchParams(window.location.search);
const clientIdFromUrl = urlParams.get("client_id");

if (clientIdFromUrl && currentClientId && parseInt(clientIdFromUrl, 10) !== parseInt(currentClientId, 10)) {
  window.location.href = "/404";
}

const App = () => {
  const [urole, setURole] = useState("");
  const [isLogin, setIsLogin] = useState(false);
  const [gauth, setGauth] = useState(false);

  const slugarr = window.location.pathname.substr(1).split("/");

  useEffect(() => {
    if (slugarr[0] === "gauth-callback") {
      setGauth(true);
    } else if (slugarr[0] === "lead_view") {
      setGauth(true);
    } else if (localStorage.getItem("userData") === null && slugarr[0] === "login") {
      setIsLogin(false);
    } else if (localStorage.getItem("userData") === null) {
      setIsLogin(false);
      if (slugarr[0] !== "forgot_password" && slugarr[0] !== "reset_password") {
        window.location.assign("/login");
      }
    } else {
      setIsLogin(true);
      const loginData = JSON.parse(localStorage.getItem("userData"));
      setURole(loginData.data.role);

      if (slugarr[0] === "forgot_password" || slugarr[0] === "reset_password" || slugarr[0] === "login") {
        window.location.assign("/");
      }
    }
  }, []);
  
  if (isLogin === true) {
    
    if (urole === "Sales Manager") {
      return (
        <CPHandlerProvider>
          <BrowserRouter>
            <React.Suspense
              fallback={
                <div className="lazyLoader">
                  <span></span>
                </div>
              }
            >
              <Routes>
                <Route exact path="/" element={<RecordList />} />
                <Route exact path="/dashboard" element={<RecordList />} />
                <Route path="/leads" element={<LeadAddNew />} />
                <Route path="/lead_addnew" element={<LeadAddNew />} />
                <Route path="/lead_view" element={<LeadView />} />
                <Route path="/lead_edit" element={<LeadEdit />} />
                <Route path="/incoming" element={<LeadIncoming />} />
                <Route path="/lead_board" element={<LeadBoard />} />
                <Route path="/lead_client_dash" element={<LeadClientDash />} />
                
                <Route path="/404" element={<NotFound />} />
                <Route path="*" element={<NotFound />} />
                <Route path="/class_doc" element={<ClassDoc />} />
                <Route path="/form_preview" element={<FormPreview />} />                
              </Routes>
            </React.Suspense>
          </BrowserRouter>
        </CPHandlerProvider>
      );  
    } else if (urole === "Chat Person" || urole === "Chat Manager") {
      return (
        <CPHandlerProvider>
          <BrowserRouter>
            <React.Suspense
              fallback={
                <div className="lazyLoader">
                  <span></span>
                </div>
              }
            >
              <Routes>
                <Route exact path="/" element={<RecordList />} />
                <Route exact path="/dashboard" element={<RecordList />} />

                <Route path="/faqs" element={<FaqList />} />
                <Route path="/faqs_edit" element={<FaqList />} />
                <Route path="/faq_cats" element={<FaqCatsList />} />
                <Route path="/faq_cats_edit" element={<FaqCatsList />} />
                <Route path="/faq_tags" element={<FaqTagsList />} />
                <Route path="/faq_tags_edit" element={<FaqTagsList />} />
                <Route path="/faq_synonyms" element={<FaqSynonymsList />} />
                <Route path="/faq_synonyms_edit" element={<FaqSynonymsList />} />
                <Route path="/faq_ques" element={<FaqQuesList />} />
                <Route path="/faq_ques_edit" element={<FaqQuesList />} />
                <Route path="/faq_ans" element={<FaqAnsList />} />
                <Route path="/faq_ans_edit" element={<FaqAnsList />} />
                <Route path="/faq_suggested" element={<FaqSuggestedAdd />} />
                <Route path="/faq_suggested_edit" element={<FaqSuggestedEdit />} />
                <Route path="/faq_suggested_v2" element={<FaqSuggestedAdd_v2 />} />
                <Route  path="/faq_suggested_edit_v2"  element={<FaqSuggestedEdit_v2 />} />
                <Route path="/snippets" element={<SnippetsList />} />
                <Route path="/snippets_edit" element={<SnippetsList />} />

                <Route path="/chat_trainings" element={<FaqChattrainingList />} />
                <Route path="/chat_trainings_edit" element={<FaqChattrainingList />} />

                <Route path="/chat_settings" element={<ChatPicAdd />} />
                <Route path="/chat-dash" element={<ChatDash />} />
                <Route path="/chats" element={<ChatsListPopup />} />
                <Route path="/chat_message" element={<ChatMessageView />} />
                <Route path="/chat_blocked_ips" element={<ChatBlockedIPs />} />
                <Route path="/nltk" element={<NLTK />} />

                <Route path="/chat_domain" element={<ChatDomainList />} />
                <Route path="/chat_domain_edit" element={<ChatDomainList />} />

                <Route path="/404" element={<NotFound />} />
                <Route path="*" element={<NotFound />} />
                <Route path="/class_doc" element={<ClassDoc />} />
                <Route path="/form_preview" element={<FormPreview />} />
              </Routes>
            </React.Suspense>
          </BrowserRouter>
        </CPHandlerProvider>
      );  
    } else {
      return (
        <CPHandlerProvider>
          <BrowserRouter>
            <React.Suspense
              fallback={
                <div className="lazyLoader">
                  <span></span>
                </div>
              }
            >
              <Routes>
                <Route path="/chat-dash" element={<ChatDash />} />
                <Route path="/chats" element={<ChatsListPopup />} />
                <Route path="/chat_message" element={<ChatMessageView />} />
                <Route path="/chat_blocked_ips" element={<ChatBlockedIPs />} />
                <Route path="/nltk" element={<NLTK />} />

                <Route path="/chat_domain" element={<ChatDomainList />} />
                <Route path="/chat_domain_edit" element={<ChatDomainList />} />

                <Route exact path="/" element={<RecordList />} />
                <Route exact path="/dashboard" element={<RecordList />} />

                <Route path="/leads" element={<LeadsList />} />
                <Route path="/lead_view" element={<LeadView />} />
                <Route path="/lead_addnew" element={<LeadsList />} />
                <Route path="/lead_edit" element={<LeadsList />} />
                <Route path="/lead_call" element={<LeadCalls />} />
                <Route path="/lead_edit_test_sms" element={<LeadEditTest />} />
                <Route path="/lead_crm" element={<LeadCRM />} />
                <Route path="/incoming" element={<TwilioIncoming />} />
                <Route path="/token" element={<TwilioToken />} />
                <Route path="/voice" element={<TwilioOutgoing />} />
                <Route path="/lead_board" element={<LeadBoard />} />
                <Route path="/lead_client_dash" element={<LeadClientDash />} />
                <Route path="/lead_cats" element={<LeadCatsList />} />
                <Route path="/lead_cats_edit" element={<LeadCatsList />} />

                <Route path="/leadstatus" element={<LeadStatusList />} />
                <Route path="/leadstatus_edit" element={<LeadStatusList />} />

                <Route path="/leadtype" element={<LeadTypeList />} />
                <Route path="/leadtype_edit" element={<LeadTypeList />} />

                <Route path="/leadcontacts" element={<LeadContactList />} />
                <Route path="/leadcontact_edit" element={<LeadContactList />} />

                <Route path="/lead_sms" element={<LeadSms />} />
                <Route path="/lead_sms_edit" element={<LeadSms />} />

                <Route path="/leadmails" element={<LeadMails />} />
                <Route path="/leadmails_edit" element={<LeadMails />} />

                <Route path="/inbox" element={<InboxList />} />
                <Route path="/inbox_edit" element={<InboxList />} />

                <Route
                  path="/leademailgroup"
                  element={<LeadEmailGroupList />}
                />
                <Route
                  path="/leademailgroup_edit"
                  element={<LeadEmailGroupList />}
                />

                <Route
                  path="/leadassigned_user"
                  element={<LeadAssignedUser />}
                />
                <Route
                  path="/leadassigned_user_edit"
                  element={<LeadAssignedUser />}
                />

                <Route path="/lead_setting" element={<LeadSetting />} />
                <Route path="/lead_setting_edit" element={<LeadSetting />} />

                <Route path="/clients" element={<ClientsList />} />
                <Route path="/client_edit" element={<ClientsList />} />

                <Route path="/lp_new" element={<LandingPageList />} />
                <Route path="/lp_edit" element={<LandingPageList />} />

                <Route path="/vartexts" element={<VarTextsAdd />} />
                <Route path="/vartext_edit" element={<VarTextsEdit />} />

                <Route path="/templates" element={<TemplatesList />} />
                <Route path="/template_edit" element={<TemplatesList />} />
                <Route path="/template_kanban" element={<Kanban />} />

                <Route path="/themes" element={<ThemesList />} />
                <Route path="/theme_edit" element={<ThemesList />} />

                <Route path="/groups" element={<GroupsAdd />} />
                <Route path="/groups_edit" element={<GroupsEdit />} />

                <Route path="/users" element={<UsersList />} />
                <Route path="/user_edit" element={<UsersList />} />

                <Route path="/roles" element={<RolesAdd />} />
                <Route path="/roles_edit" element={<RolesEdit />} />

                <Route path="/permissions" element={<PermissionsAdd />} />
                <Route path="/permissions_edit" element={<PermissionsEdit />} />

                <Route path="/html_blocks" element={<HtmlBlocksList />} />
                <Route path="/html_block_edit" element={<HtmlBlocksList />} />
                <Route
                  path="/html_block_sets"
                  element={<HtmlBlocksSetList />}
                />
                <Route
                  path="/html_block_set_edit"
                  element={<HtmlBlocksSetList />}
                />

                <Route path="/benefit" element={<BenefitList />} />
                <Route path="/benefit_edit" element={<BenefitList />} />
                <Route path="/benefit_set" element={<BenefitSetList />} />
                <Route path="/benefit_set_edit" element={<BenefitSetList />} />

                <Route path="/testimonial" element={<TestimonialList />} />
                <Route path="/testimonial_edit" element={<TestimonialList />} />
                <Route
                  path="/testimonial_set"
                  element={<TestimonialSetList />}
                />
                <Route
                  path="/testimonial_set_edit"
                  element={<TestimonialSetList />}
                />

                <Route path="/objection" element={<ObjectionList />} />
                <Route path="/objection_edit" element={<ObjectionList />} />
                <Route path="/objection_set" element={<ObjectionSetList />} />
                <Route
                  path="/objection_set_edit"
                  element={<ObjectionSetList />}
                />

                <Route path="/lpbuilder" element={<LPBuilder />} />

                <Route path="/faqs" element={<FaqList />} />
                <Route path="/faqs_edit" element={<FaqList />} />
                <Route path="/faq_cats" element={<FaqCatsList />} />
                <Route path="/faq_cats_edit" element={<FaqCatsList />} />
                <Route path="/faq_tags" element={<FaqTagsList />} />
                <Route path="/faq_tags_edit" element={<FaqTagsList />} />
                <Route path="/faq_synonyms" element={<FaqSynonymsList />} />
                <Route path="/faq_synonyms_edit" element={<FaqSynonymsList />} />
                <Route path="/faq_ques" element={<FaqQuesList />} />
                <Route path="/faq_ques_edit" element={<FaqQuesList />} />
                <Route path="/faq_ans" element={<FaqAnsList />} />
                <Route path="/faq_ans_edit" element={<FaqAnsList />} />
                <Route path="/faq_suggested" element={<FaqSuggestedAdd />} />
                <Route path="/faq_suggested_edit" element={<FaqSuggestedEdit />} />
                <Route path="/faq_suggested_v2" element={<FaqSuggestedAdd_v2 />} />
                <Route  path="/faq_suggested_edit_v2"  element={<FaqSuggestedEdit_v2 />} />
                <Route path="/snippets" element={<SnippetsList />} />
                <Route path="/snippets_edit" element={<SnippetsList />} />

                <Route path="/chat_trainings" element={<FaqChattrainingList />} />
                <Route path="/chat_trainings_edit" element={<FaqChattrainingList />} />

                <Route path="/chat_settings" element={<ChatPicAdd />} />

                <Route path="/lead-test-form" element={<NcmForm />} />
                <Route path="/gmail-api" element={<GmailApi />} />

                <Route path="/post" element={<PostList />} />
                <Route path="/post_edit" element={<PostList />} />
                <Route path="/post_cat" element={<PostCatList />} />
                <Route path="/post_cat_edit" element={<PostCatList />} />

                <Route path="/post_setting" element={<PostSettingList />} />
                <Route path="/post_setting_by_name" element={<PostByname />} />

                <Route path="/pages" element={<PagesList />} />
                <Route path="/page_edit" element={<PagesList />} />

                <Route path="/websites" element={<WebsitesList />} />
                <Route path="/website_edit" element={<WebsitesList />} />

                <Route path="/site" element={<SiteList />} />

                <Route path="/message" element={<MessageList />} />
                <Route path="/message_edit" element={<MessageList />} />
				
				<Route path="/accordion" element={<AccordionList />} />
                <Route path="/accordion_edit" element={<AccordionList />} />

                <Route path="/quotes" element={<QuotesList />} />
                <Route path="/quote_edit" element={<QuotesList />} />

                <Route path="/showcases" element={<ShowcasesList />} />
                <Route path="/showcase_edit" element={<ShowcasesList />} />

                <Route path="/videos" element={<VideosList />} />
                <Route path="/videos_edit" element={<VideosList />} />

                <Route path="/contact_text" element={<ContactTextList />} />
                <Route
                  path="/contact_text_edit"
                  element={<ContactTextList />}
                />

                <Route path="/virtual_tours" element={<VirtualToursList />} />
                <Route
                  path="/virtual_tour_edit"
                  element={<VirtualToursList />}
                />

                <Route path="/widget_setting" element={<WidgetSettingList />} />
                <Route path="/widget_setting_edit" element={<WidgetSettingList />} />

                <Route path="/offers" element={<OffersFormList />} />
                <Route path="/offer_edit" element={<OffersFormList />} />

                <Route path="/site_theme" element={<SiteThemeList />} />
                <Route path="/site_theme_edit" element={<SiteThemeList />} />

                <Route path="/form_builder" element={<FormBuilderList />} />
                <Route path="/form_builder_edit" element={<FormBuilderList />} />
				
                <Route path="/form_entries" element={<FormEntriesList />} />
                <Route path="/form_entries_edit" element={<FormEntriesList />} />

                <Route
                  path="/custom_form_addnew"
                  element={<CustomFormList />}
                />
                <Route path="/custom_form_edit" element={<CustomFormList />} />

                <Route path="/offer_groups" element={<OffersGroupsList />} />
                <Route
                  path="/offer_group_edit"
                  element={<OffersGroupsList />}
                />

                <Route path="/email_temps" element={<EmailTempsList />} />
                <Route path="/email_temp_edit" element={<EmailTempsList />} />

                <Route path="/email_groups" element={<EmailGroupsList />} />
                <Route path="/email_group_edit" element={<EmailGroupsList />} />

                <Route path="/email_filters" element={<EmailFilteringList />} />
                <Route path="/email_filters_edit" element={<EmailFilteringList />} />

                <Route path="/widget_image_setting" element={<WidgetImageSettingList />} />
                <Route path="/widget_image_setting_edit" element={<WidgetImageSettingList />} />

                <Route path="/heroes" element={<HeroesList />} />
                <Route path="/heroes_edit" element={<HeroesList />} />

                <Route
                  path="/clientgalleryimages"
                  element={<ClientGalleryImagesList />}
                />
                <Route
                  path="/clientgalleryimage_edit"
                  element={<ClientGalleryImagesList />}
                />

                <Route
                  path="/clientstoryboards"
                  element={<ClientStoryBoardsList />}
                />
                <Route
                  path="/clientstoryboard_edit"
                  element={<ClientStoryBoardsList />}
                />

                <Route
                  path="/followup_email_temps"
                  element={<FollowUpEmailTempsAdd />}
                />
                <Route
                  path="/followup_email_temp_edit"
                  element={<FollowUpEmailTempsEdit />}
                />

                <Route
                  path="/followup_email_groups"
                  element={<FollowUpEmailGroupsAdd />}
                />
                <Route
                  path="/followup_email_group_edit"
                  element={<FollowUpEmailGroupsEdit />}
                />

                <Route path="/media" element={<MediaList />} />
                <Route path="/media_edit" element={<MediaList />} />

                <Route path="/media_photos" element={<MediaPhotosList />} />
                <Route path="/media_photos_edit" element={<MediaPhotosList />} />

                <Route path="/media_videos" element={<MediaVideosList />} />
                <Route path="/media_videos_edit" element={<MediaVideosList />} />

                <Route path="/lpsessions" element={<LpsessionAdd />} />
                <Route path="/lpsession_view" element={<LpsessionEdit />} />

                <Route path="/workbooks" element={<WorkbooksList />} />
                <Route path="/workbooks_edit" element={<WorkbooksList />} />
                <Route path="/workbook_editor" element={<WorkbookEditor />} />

                <Route path="/test" element={<TestAdd />} />
                <Route path="/test_edit" element={<TestEdit />} />

                <Route path="/404" element={<NotFound />} />
                <Route path="*" element={<NotFound />} />
                <Route path="/class_doc" element={<ClassDoc />} />
                <Route path="/form_preview" element={<FormPreview />} />
              </Routes>
            </React.Suspense>
          </BrowserRouter>
        </CPHandlerProvider>
      );
    }
  } else if (gauth === true) {
    return (
      <BrowserRouter>
        <React.Suspense
          fallback={
            <div className="lazyLoader">
              <span></span>
            </div>
          }
        >
          <Routes>
            <Route path="/gauth-callback" element={<GoogleToken />} />
            <Route path="/lead_view" element={<LeadView />} />
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    );
  } else {
    return (
      <BrowserRouter>
        <React.Suspense
          fallback={
            <div className="lazyLoader">
              <span></span>
            </div>
          }
        >
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot_password" element={<ForgotPassword />} />
            <Route path="/reset_password" element={<ResetPassword />} />
            <Route path="/gauth-callback" element={<GoogleToken />} />
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    );
  }
};

export default App;
